import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import {
    LanguageDetectionService,
    LanguageInfo,
} from '../../_services/language-detection.service';

@Component({
    selector: 'on-language-switcher',
    templateUrl: './language-switcher.component.html',
    styleUrls: ['./language-switcher.component.scss'],
})
export class LanguageSwitcherComponent implements OnInit {
    languages: LanguageInfo[] = [];
    currentLanguage: LanguageInfo;

    constructor(
        private translateService: TranslateService,
        private languageDetectionService: LanguageDetectionService,
    ) {}

    ngOnInit() {
        this.languages = this.languageDetectionService.getSupportedLanguages();
        this.currentLanguage = this.getCurrentLanguage();
        this.languageDetectionService.loadLanguageFromApi();
    }

    private getCurrentLanguage(): LanguageInfo {
        const currentLangCode = this.translateService.currentLang;
        return (
            this.languages.find((lang) => lang.code === currentLangCode) ||
            this.languages[0]
        );
    }

    onLanguageSelect(selectedLanguage: LanguageInfo) {
        if (selectedLanguage.code !== this.translateService.currentLang) {
            this.currentLanguage = selectedLanguage;
            this.languageDetectionService.changeLanguage(selectedLanguage.code);
        }
    }
}
